module.exports = __webpack_public_path__ + "img/picture_ksdsb.adce61d8.png";